import BannerTiles from './BannerTiles';

export default BannerTiles;
